import React, { useRef, useState } from 'react';
import './DateInput.scss';
import Calender from '../../assets/icons/calendar.svg';
import { GreenCheckBox } from '../greenCheckboxes/greenCheckBox';

interface IDateInput {
  title: string;
  hasDisabled?: boolean;
  placeHolder?: string;
  rightTight?: boolean;
}

const dateInput = ({ title, hasDisabled = false, rightTight = false }: IDateInput) => {
  const [date, setDate] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);

  const calendarRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (calendarRef.current && !disabled) {
      calendarRef.current?.showPicker();
    }
  };

  const setDisabledInput = (value: boolean) => {
    setDate('');
    setDisabled(value);
  };

  return (
    <div className="dateInputComponent" style={{ marginRight: rightTight ? '0px' : '13px' }}>
      {hasDisabled ? (
        <div className="disabledDateInputContainer">
          <div className={`dateInput ${disabled ? '' : 'hidden'}`}>
            <div className="dateText" style={{ color: date === '' ? '#C1C1C1' : 'black' }}>
              {date === '' ? title : date}
            </div>
            <input
              ref={calendarRef}
              type="date"
              style={{ visibility: 'hidden', width: '0px' }}
              onChange={(e) => {
                setDate(String(e.target.value).replace('-', '.').replace('-', '.'));
              }}
            />
            <img src={Calender} alt="" className="calenderImage" onClick={handleButtonClick} />
          </div>
          <div className="disableButtonContainer">
            <GreenCheckBox
              onCheck={() => {
                setDisabledInput(!disabled);
              }}
              defaultValue={disabled}
              text={'미정'}
            />
          </div>
        </div>
      ) : (
        <div className="dateInputContainer">
          <div className="dateText" style={{ color: date === '' ? '#C1C1C1' : 'black' }}>
            {date === '' ? title : date}
          </div>
          <input
            ref={calendarRef}
            type="date"
            style={{ visibility: 'hidden', width: '0px' }}
            onChange={(e) => {
              setDate(String(e.target.value).replace('-', '.').replace('-', '.'));
            }}
          />
          <img src={Calender} alt="" className="calenderImage" onClick={handleButtonClick} />
        </div>
      )}
    </div>
  );
};

export default dateInput;
